import { render, staticRenderFns } from "./SfMegaMenuColumn.vue?vue&type=template&id=d0024d7e&"
import script from "./SfMegaMenuColumn.vue?vue&type=script&lang=js&"
export * from "./SfMegaMenuColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports